import { render } from "./PantryCategoryTitleView.vue?vue&type=template&id=041f59e5&ts=true"
import script from "./PantryCategoryTitleView.vue?vue&type=script&lang=ts"
export * from "./PantryCategoryTitleView.vue?vue&type=script&lang=ts"

import "./PantryCategoryTitleView.vue?vue&type=style&index=0&id=041f59e5&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__